const connectivePartnerId = 'ghn9l60ggkykun026ptru67l3v66akwx'
export const PARTNER_LENDER_EXCLUSION_LIST = {
  [connectivePartnerId]: ['Liberty', 'Money Place', 'Moula'],
}
